import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowchevron2UpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="arrowchevron2_up_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M542.165 225.835a42.667 42.667 0 0 0-60.33 0L268.5 439.168a42.667 42.667 0 1 0 60.331 60.33L512 316.332 695.168 499.5a42.667 42.667 0 0 0 60.33-60.331L542.166 225.835zm213.334 512L542.165 524.5a42.667 42.667 0 0 0-60.33 0L268.5 737.835a42.667 42.667 0 1 0 60.331 60.33L512 614.997l183.168 183.168a42.667 42.667 0 0 0 60.33-60.33z"
    />
  </svg>
);
export default SvgArrowchevron2UpIcon;
